module.exports = __webpack_public_path__ + "static/img/recommend_img_02.5eadd22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recommend_img_02.png
// module id = LVnh
// module chunks = 1